import React, { useCallback, useEffect, useState } from "react";
import MyInquiry from "../MyInquiry";
import { UserAgentType } from "../../../interface/common/common.inferface";
import { InquiryInterface } from "../../../interface/list/list.interface";
import { useNavigate } from "react-router-dom";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../reducer";
import { collection, getDocs, query, where } from "firebase/firestore";
import { db } from "../../../config/firebase";
import { LoadingChange } from "../../../reducer/config";
type Props = {
  userAgent: UserAgentType;
};

const MyInquiryContainer = ({ userAgent }: Props) => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const isLogin = useSelector<RootState, string | undefined>(
    (state) => state.auth.uid
  );
  const [InquiryData, setInquiryData] = useState<InquiryInterface[]>([]);
  const [displayData, setDisplayData] = useState<InquiryInterface[]>([]);
  const [SearchText, setSearchText] = useState<string>("");

  const NavWrite = () => {
    if (isLogin) {
      navigate("/user/write");
    }
  };

  const OnChangeText = useCallback((e: React.ChangeEvent<HTMLInputElement>) => {
    setSearchText(e.target.value);
  }, []);

  useEffect(() => {
    const clone = InquiryData.slice();
    if (SearchText) {
      const arr = clone.filter((item) => item.content.includes(SearchText));
      setDisplayData(arr);
    } else {
      setDisplayData(InquiryData);
    }

    return () => {};
  }, [SearchText]);

  useEffect(() => {
    if (isLogin) {
      dispatch(LoadingChange(true));
      let arr: InquiryInterface[] = [];
      getDocs(
        query(collection(db, "inquiry"), where("uid", "==", isLogin))
      ).then((docs) => {
        docs.forEach((item) => {
          arr.push(item.data() as InquiryInterface);
        });
        setInquiryData(arr);
        setDisplayData(arr);
        dispatch(LoadingChange(false));
      });
    }
    return () => {};
  }, [isLogin]);

  return (
    <MyInquiry
      userAgent={userAgent}
      data={displayData}
      NavWrite={NavWrite}
      isLogin={isLogin}
      OnChangeText={OnChangeText}
    />
  );
};

export default MyInquiryContainer;
